import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StateSliceName } from 'state/StateSliceName';

export interface MergeProfilesPhoneNumber {
  id: string | null;
  number: string | null;
  isPrimary: boolean;
  isSelected: boolean;
  verifiedMobile: boolean;
}

export interface MergeProfilesContactPreferences {
  email: boolean;
  emailOptedOut?: boolean;
  sms: boolean;
  smsOptedOut?: boolean;
}

export interface MergeProfilesPet {
  id: string | null;
  name: string | null;
}

interface MergeProfilesResult {
  name: string | null;
  phoneNumbers: MergeProfilesPhoneNumber[];
  email: string | null;
  sendSurvey: boolean;
  contactPreferences: MergeProfilesContactPreferences | null;
  pets: MergeProfilesPet[];
}

const initialMergeProfileResult: MergeProfilesResult = {
  name: null,
  phoneNumbers: [],
  email: null,
  sendSurvey: true,
  contactPreferences: {
    email: true,
    sms: true,
  },
  pets: [],
};

interface MergeProfilesState {
  mergeProfileResult: MergeProfilesResult;
  pimsProfile: boolean;
  secondProfileIsPrimary: boolean;
}

const initialState: MergeProfilesState = {
  mergeProfileResult: initialMergeProfileResult,
  pimsProfile: false,
  secondProfileIsPrimary: false,
};

const mergeProfilesSlice = createSlice({
  name: StateSliceName.MergeProfiles,
  initialState,
  reducers: {
    resetMergeProfilesResult: (state) => {
      return {
        mergeProfileResult: initialState.mergeProfileResult,
        pimsProfile: state.pimsProfile,
        secondProfileIsPrimary: state.secondProfileIsPrimary,
      };
    },
    updateMergeProfilesResult: (state, action: PayloadAction<Partial<MergeProfilesResult>>) => {
      Object.assign(state.mergeProfileResult, action.payload);
    },
    updateMergeProfilesPhoneNumbers: (state, action: PayloadAction<MergeProfilesPhoneNumber[]>) => {
      state.mergeProfileResult.phoneNumbers = action.payload || [];
    },
    setPimsProfile: (state, action: PayloadAction<boolean>) => {
      state.pimsProfile = action.payload;
    },
    setSecondProfileIsPrimary: (state, action: PayloadAction<boolean>) => {
      state.secondProfileIsPrimary = action.payload;
    },
  },
});

export const {
  resetMergeProfilesResult,
  updateMergeProfilesResult,
  updateMergeProfilesPhoneNumbers,
  setPimsProfile,
  setSecondProfileIsPrimary,
} = mergeProfilesSlice.actions;

export default mergeProfilesSlice.reducer;
